import React, {useCallback, useEffect, useState} from 'react';
import {HealthContainer} from '../components/HealthContainer/healthContainer';
import {UsersTable} from './usersTable/usersTable';
import {TablePagination} from '../components/TablePagination/TablePagination';
import {subDays, startOfDay, endOfDay, format} from 'date-fns';
import {AppService} from '../../../dataServices/appService';
import {toast} from 'react-toastify';
import {HttpAdminHealthUser} from '../../../dataServices/app.generated';
import {useHistory} from 'react-router';

export const HealthUsers = () => {
  const history = useHistory();
  const [users, setUsers] = useState<HttpAdminHealthUser[]>([]);
  const [totCount, setTotCount] = useState(0);
  const [currPage, setCurrPage] = useState(0);
  const [startDate, setStartDate] = useState(startOfDay(subDays(new Date(), 7)));
  const [endDate, setEndDate] = useState(endOfDay(new Date()));
  const [loading, setLoading] = useState(false);
  const [memberId, setMemberId] = useState('');
  const [groupCode, setGroupCode] = useState('');

  useEffect(() => {
    const params = new URLSearchParams(history.location.search);
    const page = params.get('page');
    if (page) {
      setCurrPage(parseInt(page));
    }

    const start = params.get('startDate');
    const end = params.get('endDate');
    if (start && end) {
      setStartDate(new Date(start));
      setEndDate(new Date(end));
    }
  }, [history.location.search]);

  const onQueryError = () => {
    setLoading(false);
    toast('There was an error while loading the users.');
  };

  const queryUsers = useCallback(() => {
    setLoading(true);
    setUsers([]);
    AppService.adminPartnerHealthClient
      .getHealthUsers(
        {
          count: '30',
          offset: String(30 * currPage),
          startDate: String(startOfDay(startDate)),
          endDate: String(endOfDay(endDate)),
          memberId,
          groupCode,
        },
        {'404': onQueryError}
      )
      .then((res) => {
        setLoading(false);
        if (!res) {
          return;
        }
        setTotCount(res.count);
        setUsers(res.users);
      });
  }, [startDate, endDate, currPage, groupCode, memberId]);

  useEffect(() => {
    queryUsers();
  }, [currPage, startDate, endDate]);

  const navPrevPage = () => {
    if (currPage === 0) {
      return;
    }
    history.push(
      `/health/users?page=${currPage - 1}&startDate=${format(startDate, 'MM-dd-yyyy')}&endDate=${format(
        endDate,
        'MM-dd-yyyy'
      )}`
    );
  };

  const navNextPage = () => {
    history.push(
      `/health/users?page=${currPage + 1}&startDate=${format(startDate, 'MM-dd-yyyy')}&endDate=${format(
        endDate,
        'MM-dd-yyyy'
      )}`
    );
  };

  const onSetStartDate = (date: Date) => {
    if (!date) {
      return;
    }
    const startParam = format(date, 'MM-dd-yyyy');
    const endParam = format(endDate, 'MM-dd-yyyy');
    history.push(`/health/users?page=${currPage}&startDate=${startParam}&endDate=${endParam}`);
  };

  const onSetEndDate = (date: Date) => {
    if (!date) {
      return;
    }
    const startParam = format(startDate, 'MM-dd-yyyy');
    const endParam = format(date, 'MM-dd-yyyy');
    history.push(`/health/users?page=${currPage}&startDate=${startParam}&endDate=${endParam}`);
  };

  return (
    <HealthContainer title={'Clever Health Users'}>
      <UsersTable
        usersList={users}
        startDate={startDate}
        setStartDate={onSetStartDate}
        endDate={endDate}
        onQuery={queryUsers}
        setEndDate={onSetEndDate}
        loading={loading}
        memberId={memberId}
        setMemberId={setMemberId}
        groupCode={groupCode}
        setGroupCode={setGroupCode}
      />
      <TablePagination
        totCount={totCount}
        currPage={currPage}
        itemsPerPage={30}
        onNavNext={navNextPage}
        onNavPrev={navPrevPage}
      />
    </HealthContainer>
  );
};
